import { useState, useEffect } from 'react';
import { usePolaroidQueue } from '../hooks/usePolaroidQueue';

const EXIBICAO_MS  = 12_000;
const SAIDA_INICIO = EXIBICAO_MS - 400;

export default function TvPolaroidOverlay({ telaId }: { telaId: string }) {
  const { atual } = usePolaroidQueue(telaId);
  const [saindo, setSaindo] = useState(false);

  useEffect(() => {
    if (!atual) { setSaindo(false); return; }
    setSaindo(false);
    const t = setTimeout(() => setSaindo(true), SAIDA_INICIO);
    return () => clearTimeout(t);
  }, [atual?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!atual) return null;

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none">
      {/* key no polaroid: força remount a cada nova foto, reiniciando a animação CSS */}
      <div
        key={atual.id}
        className={`absolute bottom-8 left-8 ${saindo ? 'animate-polaroid-out' : 'animate-polaroid-in'}`}
        style={{ filter: 'drop-shadow(0 24px 48px rgba(0,0,0,0.75))' }}
      >
        {/* Corpo branco do polaroid */}
        <div className="bg-white p-[clamp(14px,1.4vw,22px)] pb-[clamp(56px,6vw,100px)] w-[clamp(260px,26vw,420px)]">
          {/* Foto */}
          <div className="w-full aspect-[4/3] overflow-hidden bg-zinc-100">
            <img
              src={atual.url}
              alt="Polaroid do cliente"
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>

          {/* Identificação na borda branca inferior */}
          {atual.identificacao && (
            <p
              className="absolute bottom-0 left-0 right-0 flex items-center justify-center text-zinc-800 font-bold tracking-tight text-center leading-none"
              style={{
                height:     'clamp(56px,6vw,100px)',
                fontSize:   'clamp(16px,1.8vw,28px)',
                fontFamily: "'Georgia', 'Times New Roman', serif",
                fontStyle:  'italic',
              }}
            >
              {atual.identificacao}
            </p>
          )}
        </div>

        {/* Ícone de câmera */}
        <div
          className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-lg"
          aria-hidden
        >
          <svg className="w-4.5 h-4.5 text-zinc-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
      </div>
    </div>
  );
}
